import { render, staticRenderFns } from "./SalesTaxFiling.vue?vue&type=template&id=1944d592&scoped=true&"
import script from "./SalesTaxFiling.vue?vue&type=script&lang=js&"
export * from "./SalesTaxFiling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1944d592",
  null
  
)

export default component.exports